import "core-js/stable";
import "regenerator-runtime/runtime";
import './polyfills.js'
import log from '/js/common/Logger';
import _ from 'lodash'
import Utils from './common/Utils.js';
import Analytics from './EfeAnalytics'
import mobileMenuTemplate from './mobile_menu.html'
import {loadPlaywire} from "./ads/video/playwire";

(function () {
    const ver = '1.3.6';
    Analytics.sendEvent('dev', 'init', ver);
    console.log(`v${ver}`);
    const contentEl = document.getElementById('content');
    //const mobileMenuEl = document.getElementById('mobile-menu');
    const leftNavItemsContainerEl = document.querySelector('#leftNav ul.nav-items-container');
    const asideEl = document.querySelector('aside');
    const leftNavFooterEl = document.getElementById('left-nav-footer');

    function doMobileLogic() {
        createMobileMenu();
        const div = document.createElement('div');
        div.innerHTML = '<h1>More topics:</h1></h1><ul class="navigation">'+leftNavItemsContainerEl.outerHTML+'</ul>'
        for (let i=0; i<div.children; i++) {
            contentEl.appendChild(div.children[i]);
        }
        let isMenuExpanded = false;
        function toggleMenu() {
            isMenuExpanded = !isMenuExpanded;
            leftNavItemsContainerEl.style.display = isMenuExpanded ? 'block' : 'none';
            document.documentElement.style.height = isMenuExpanded ? '100vh' : null;
            document.documentElement.style.overflow = isMenuExpanded ? 'hidden' : 'auto';
            document.body.style.height = isMenuExpanded ? '100vh' : null;
            document.body.style.overflow = isMenuExpanded ? 'hidden' : 'auto';
            document.querySelector('.icon-menu').classList.toggle('hide');
            document.querySelector('.icon-close').classList.toggle('hide');
        }
        function createMobileMenu() {
            const tmpDiv = document.createElement('div');
            tmpDiv.innerHTML = mobileMenuTemplate
            tmpDiv.children[0].children[0].addEventListener('click', toggleMenu);
            tmpDiv.children[0].children[1].addEventListener('click', toggleMenu);
            document.body.appendChild(tmpDiv.children[0]);
            fixSideNav();
        }
        function fixSideNav() {
            leftNavItemsContainerEl.classList.add('mobile-menu__content');
            leftNavItemsContainerEl.style.display = 'none';
            leftNavItemsContainerEl.style.position = 'absolute';
            leftNavItemsContainerEl.style.left = 0;
            leftNavItemsContainerEl.style.top = 0;
            leftNavItemsContainerEl.parentElement.removeChild(leftNavItemsContainerEl);

            const workbooksLi = document.querySelector('#workbooks ul > li');
            leftNavItemsContainerEl.insertBefore(workbooksLi, leftNavItemsContainerEl.children[0]);
            document.body.appendChild(leftNavItemsContainerEl);
            asideEl.parentElement.removeChild(asideEl);
        }


        // mobileMenuEl.style.display = 'block';
        // mobileMenuEl.addEventListener('click', toggleMenu);
    }

    function getWidth(el) {
        return parseFloat(getComputedStyle(el, null).width.replace("px", ""));
    }

    function getHeight(el) {
        return parseFloat(getComputedStyle(el, null).height.replace("px", ""))
    }

    function updatePDFLinksToPDFView() {
        const pdfLinkEls = document.querySelectorAll('a[href$=".pdf"]');
        _.forEach(pdfLinkEls, currLinkEl => {
            const pdfUrl = currLinkEl.href;
            const pdfFilename = pdfUrl.substring(pdfUrl.lastIndexOf('/') + 1);
            currLinkEl.href = '/viewpdf.html?pdf=/PDFs/' + pdfFilename + '&title=' + currLinkEl.innerText;
            currLinkEl.target = '_self';
        });
    }

    function onClickCheckout() {
        setTimeout(function() {
            window.ga('main.send', 'event', 'banner', 'clicked')
            document.querySelector("#btn-banner-checkout").removeEventListener("click", onClickCheckout);
            window.location.href = '/?clicked_banner=true';
        },1000)
    }

    var screenWidth = getWidth(document.body)
    if (screenWidth <= 900) { //mobile
        doMobileLogic();
    } else {
        let contentHeight = getHeight(contentEl);
        let navHeight = getHeight(asideEl);
        let roomForLeftNavAd = contentHeight - navHeight;
        leftNavFooterEl.style.height = roomForLeftNavAd + 'px';
        let sideAdSizing = {
            width:  getWidth(leftNavFooterEl),
            height: getHeight(leftNavFooterEl)
        }
        let headerFooterAdSizing = {
            width:  getWidth(leftNavFooterEl),
        }
    }

    if (location.pathname !== '/viewpdf.html') {
        updatePDFLinksToPDFView();
    }

    //
    const NO_ADS_PATHS = [
        '/topics/privacy-policy.htm',
        '/topics/terms-of-use.htm',
        '/topics/contact.htm',
        '/topics/about-this-website.htm',
    ];

    if (_.some(NO_ADS_PATHS, path => {
        // console.log(_.toLower(location.pathname))
        // console.log(path);
        return _.contains(path, _.toLower(location.pathname))
    })) {
        console.log('disable ads on this page');
    } else {
        window.loadPlaywireVideo = loadPlaywire;
        loadPlaywire();
        const params = Utils.getUrlParams();
        if (params['banner'] || _.includes(params['title'], 'Antonyms')) {
            ga('main.send', 'event', 'banner', 'displayed');
            document.querySelector('#banner-container').style.display = 'block';
            document.querySelector("#btn-banner-checkout").addEventListener("click", onClickCheckout);
        }
    }

})();
